module.exports = __webpack_public_path__ + "img/plus.f22b26c8.svg";